import { t } from "@/i18n-js/instance";
import { SanitizeHTMLString } from "@circle-react-uikit/SanitizeContent";
import { Typography } from "@circle-react-uikit/Typography";
import { WarningWrapper } from "./WarningWrapper";

// This is a banner for users coming from SPC links
export const SpcBanner = () => (
  <WarningWrapper>
    <Typography.LabelLg weight="semibold">
      {t("pricing_plans.spc.banner.title")}
    </Typography.LabelLg>
    <Typography.BodyMd color="text-default">
      <SanitizeHTMLString content={t("pricing_plans.spc.banner.subtitle")} />
    </Typography.BodyMd>
  </WarningWrapper>
);
